import formatMessage from 'format-message'
import {setupFormatMessage as sdkSetupFormatMessage} from '@instructure/quiz-i18n'
import moment from 'moment-timezone'
import generateId from 'format-message-generate-id/underscored_crc32'

export function initTranslations({locale, momentLocale} = {}) {
  // Use provided window.locale or fall back to passed-in locale
  const finalLocale = window.locale || locale
  const finalMomentLocale = window.moment_locale || momentLocale
  return Promise.all([
    import(
      /* webpackChunkName: "translations/lti-[request]" */ `../translations/${finalLocale}.json`
    ).catch(() => ({default: {}})),
    import(
      /* webpackChunkName: "translations/outcomes-[request]" */ `@instructure/outcomes-ui/translations/${finalLocale}.json`
    ).catch(() => ({default: {}})),
    import(
      /* webpackChunkName: "translations/sdk-[request]" */ `@instructure/quiz-translations/lib/${finalLocale}.json`
    ).catch(() => ({default: {}})),
    finalMomentLocale
      ? import(
          /* webpackChunkName: "moment/locale/[request]" */ `moment/locale/${finalMomentLocale}.js`
        ).catch(() => null)
      : null,
  ]).then(result => {
    if (finalMomentLocale) {
      moment.locale(finalMomentLocale)
    }
    // Required for the handful of components (e.g. loading spinner) that are used without a SDKApp wrapper
    sdkSetupFormatMessage(finalLocale, {
      translations: result[2].default,
      logMissingTranslations: true,
    })
    formatMessage.setup({
      locale: finalLocale, // what locale strings should be displayed
      generateId,
      translations: {
        [finalLocale]: Object.assign({}, result[0].default, result[1].default),
      },
    })
    return {
      quizLti: result[0].default,
      outcomesSdk: result[1].default,
      quizSdk: result[2].default,
    }
  })
}
